"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dxdy = void 0;
const TypeHelpers_1 = require("../TypeHelpers");
const dxdy = ({ timeseries, k, tsmsDivisor, decimalRoundTo }) => {
    let res = undefined;
    const initial = { timestamp: [], [k]: [] };
    if (timeseries[k]) {
        res = timeseries.timestamp.reduce((acc, thisTimestamp, i) => {
            if (i !== 0) {
                let lastNonNull = undefined;
                let prevIdx = i;
                const thisVal = timeseries[k][i];
                if (thisVal && !isNaN(thisVal)) {
                    // skip zeros, nulls
                    do {
                        prevIdx--;
                        const prevTimestamp = timeseries.timestamp[prevIdx];
                        const prevVal = timeseries[k][prevIdx];
                        if (prevVal && !isNaN(prevVal)) {
                            const ceil = Math.ceil((thisTimestamp - prevTimestamp) / tsmsDivisor);
                            const dxdy = ceil !== 0 ? (0, TypeHelpers_1.roundDecimals)((thisVal - prevVal) / ceil, decimalRoundTo) : 0;
                            acc.timestamp.push(Math.round((prevTimestamp + thisTimestamp) / 2));
                            acc[k].push(dxdy);
                            lastNonNull = prevVal;
                        }
                    } while (prevIdx >= 0 && lastNonNull === undefined);
                }
            }
            return acc;
        }, initial);
    }
    return res;
};
exports.dxdy = dxdy;
